'use strict';

angular.module('study-environment', []);
